import { render, staticRenderFns } from "./SunNewDetail.vue?vue&type=template&id=527fac26&scoped=true&"
import script from "./SunNewDetail.vue?vue&type=script&lang=js&"
export * from "./SunNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./SunNewDetail.vue?vue&type=style&index=0&id=527fac26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fac26",
  null
  
)

export default component.exports